import { render } from "./BulkInvoicer.vue?vue&type=template&id=65839297&scoped=true"
import script from "./BulkInvoicer.vue?vue&type=script&lang=js"
export * from "./BulkInvoicer.vue?vue&type=script&lang=js"

import "./BulkInvoicer.vue?vue&type=style&index=0&id=65839297&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65839297"]])

export default __exports__